import styles from './index.module.scss';

export default function TextTitle({
    children,
    className
   }) {
    return (
        <h2 className={`${styles.title} ${className}`}>{children}</h2>
    );
}